export class Jwt {
  jwt: string;
  isValid = false;
  header: {[k: string]: any};
  payload: {[k: string]: any};
  exp: Date;
  api: string;

  constructor(jwt: string) {
    this.jwt = jwt;
    try {
      const parts = jwt.split('.');
      if (parts.length === 3) {
        this.header = JSON.parse(atob(parts[0]));
        this.payload = JSON.parse(atob(parts[1]), function(k, v) {
          if (k === 'Edr-Database-Id') {
            this.EdrDatabaseId = v;
          } else if (k === 'Edr-Schema') {
            this.EdrSchema = v;
          } else {
              return v;
          }
        });

        if (this.payload.EdrDatabaseId && this.payload.EdrSchema && this.payload.WeblinkTokenId && this.payload.exp) {
          this.exp = new Date(this.payload.exp * 1000);
          this.isValid = true;
          if ('api' in this.payload) {
            this.api = this.payload['api'];
          } else if ('MMApiUrl' in this.payload) {
            this.api = this.payload['MMApiUrl'];
          }
          if (this.api && this.api.endsWith('/')) {
            this.api = this.api.substring(0,this.api.length-1);
          }
        }
      }
    } catch(error) {}
  }
}
